import axios from 'axios'
import router from '../router'
import Qs from 'qs'



//设置全局axios默认值
axios.defaults.timeout = 1000*60*60;
axios.defaults.baseURL = process.env.BASE_API;
// axios.defaults.baseURL='https://test.koudaitry.com:8083';
// axios.defaults.baseURL='https://koudaitry.com/api/admin';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.withCredentials=true;
//创建一个axios实例
axios.defaults.headers.common['authorization'] = `Bearer ${sessionStorage.getItem("token") || ''}`;
const instance = axios.create();
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// instance.defaults.headers.post['Cache-Control'] = 'no-cache';
axios.interceptors.request.use = instance.interceptors.request.use;
/*设置全局拼接url参数*/
//request拦截器
instance.interceptors.request.use(
    config => {
        // console.log(config.data)
        console.log(config)
        config.headers['Accept-Language']='zh'
        const token = sessionStorage.getItem("token")
        if (token) {
            config.headers['authorization'] = `Bearer ${token}`
        } else {
            delete config.headers['authorization']
        }
        if(config.method=="get"){
            console.log(Qs.stringify(config.data))
            // config.data=Qs.stringify(config.data);
            config.url=config.url+"?"+Qs.stringify(config.data)
            // config.url=config.url
        }
        
        return config;  
    },
    err => {
        return Promise.reject(err);
    }
);
//respone拦截器
instance.interceptors.response.use(
    response => {
        let data= JSON.parse(response.request.response);
        // console.log(response)
        if(response.config.url=="/storage/r2-signed-url"&&JSON.parse(response.config.data).type==1){
            
            data.data.object_key=process.env.IMG_API+data.data.object_key
        }
         if(response.config.url=="/storage/r2-signed-url"&&JSON.parse(response.config.data).type==2){
            
            data.data.object_key=process.env.VIDEO_API+data.data.object_key
        }
        response=data
        if(response.code==-99){
            router.replace({ //跳转到登录页面
                path: '/admin'
            });
        }
        
        return response;
    },
    error => { //默认除了2XX之外的都是错误的，就会走这里
        return Promise.reject(error.response);
    }
);


export default instance;
   



// WEBPACK FOOTER //
// ./src/axios/index.js